import script from "./SmartHeating.vue?vue&type=script&setup=true&name=Ai_platform&lang=js"
export * from "./SmartHeating.vue?vue&type=script&setup=true&name=Ai_platform&lang=js"

import "./SmartHeating.vue?vue&type=style&index=0&id=3c1a24bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1a24bd"]])

export default __exports__